// extracted by mini-css-extract-plugin
export default {"cell":"NameCell_cell__urxbb","locked":"NameCell_locked__hlUJU","name":"NameCell_name__XW73f","icon":"NameCell_icon__JtjYg","default":"NameCell_default__iBohQ"};